import { render } from "./ShieldIcon.vue?vue&type=template&id=439b89c0"
import script from "./ShieldIcon.vue?vue&type=script&lang=js"
export * from "./ShieldIcon.vue?vue&type=script&lang=js"
script.render = render

export default script